import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthServiceInterface } from '../services/auth/auth-service.interface';

@Injectable()
export class GuestGuard {
  constructor(private router: Router, @Inject('AuthServiceInterface') private authService: AuthServiceInterface) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    // sign in via token
    if (Object.keys(route.queryParams)[0]?.length > 300) {
      this.authService.logout();
      this.router.navigate(['/auth/signin'], { queryParams: { token: Object.keys(route.queryParams || {})[0] } });
      return false;
    }

    if (this.authService.isAuthorized() && this.authService.isActiveUser()) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}
